<template>
    <el-popover
            placement="left"
            width="420"
            trigger="hover"
            :open-delay="150"
    >
        <el-timeline> <!-- 浮现的内容 -->
            <el-timeline-item
                    v-for="(craft, index) in order.craftrecord_set"
                    :key="index"
                    :timestamp="craft.timestamp">
                <span v-if="craft.finish" class="text-success">{{craft.name}}</span>
                <span v-else>{{craft.name}}</span>
                <el-divider direction="vertical"></el-divider>
                <span>{{ craft.finish_num }}件</span>
                <span v-if="craft.groups">
                    <el-divider direction="vertical"></el-divider>
                    <span style="font-size: 11px" :class="craft.finish ? 'text-success' : 'text-warning'">{{ craft.groups }}</span>
                </span>

            </el-timeline-item>
        </el-timeline>
        <el-tag slot="reference" size="small">{{ currentCraftName }}</el-tag>
    </el-popover>
</template>

<script>
    export default {
        name: "CurrentCraftCol",
        props: {
            order: Object,
            currentCraft: Object,
        },
        methods: {
            /**
             * 对工艺记录单的额外配置工作
             */
            setup_crafts() {
                if(this.order._currentCraftColsetup){
                    return
                }

                this.order.craftrecord_set.sort((a, b) => {
                    return parseInt(a.step) - parseInt(b.step)
                });

                // 2.icon 图标配置 以及 颜色配置
                // 完成的
                this.order.craftrecord_set.forEach((craft) => {
                    // const newCraft = JSON.parse(JSON.stringify(craft))

                    // 小组信息
                    let groups = []
                    for (let j = 0; j < craft.groupcraftrecord_set.length; j++) {
                        const groupInfo = craft.groupcraftrecord_set[j]
                        groups.push(groupInfo.produce_group_name)
                    }
                    groups = groups.join(", ")
                    craft["groups"] = groups

                    let timestamp = ""
                    if (craft.finish) {
                        if (craft.actual_start) {
                            timestamp += craft.actual_start
                        }

                        timestamp += ' - '

                        if (craft.actual_end) {
                            timestamp += craft.actual_end
                        }
                    }
                    craft["timestamp"] = timestamp
                    // this.craftrecord_set.push(newCraft)
                })
                this.order._currentCraftColsetup = true
            },
        },
        computed: {
            currentCraftName() {
                if (this.currentCraft) {
                    return this.currentCraft.name
                } else {
                    if (!this.current_craft) {
                        return "暂无"
                    }
                    return this.current_craft.name
                }
            },


            /**
             * 返回当前正在进行的工艺
             * @returns {Object}
             */
            current_craft() {
                for (let i = 0; i < this.order.craftrecord_set.length; i++) {
                    let craftrecord = this.order.craftrecord_set[i];

                    if (i === 0) {                // 第一个工艺,并且未完成
                        if (!craftrecord.finish) {
                            return craftrecord
                        }
                    } else if (i === this.order.craftrecord_set.length - 1) { // 最后一个工艺
                        return craftrecord
                    } else {                                             // 中间的工艺
                        let previous_craft = this.order.craftrecord_set[i - 1];
                        if (previous_craft.finish && !craftrecord.finish) {
                            return craftrecord
                        }
                    }
                }

            },
        },
        created() {
            this.setup_crafts()
        },
    }
</script>

<style scoped>

</style>